import FactureView from "@features/achats/components/factures/FactureView";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Receipt } from "lucide-react";

export const Route = createFileRoute("/_app/achats/factures/$id/view")({
  staticData: {
    title: "Détails Facture",
    icon: Receipt,
    permission: PERMISSIONS.ACHATS.FACTURES.VIEW,
    module: "achats",
    showInTab: false,
    showInNav: false,
    showInBreadcrumb: true,
  },
  component: FactureView,
});
